<template>
    <select :class="{pending}" v-model="newValue" @mousedown="userSet" @keydown="userSet" @click="userSet" @blur="$emit('blur', $event)">
        <option v-if="!currentValue" value="" :disabled="!allowUnset" :hidden="!allowUnset">
            {{placeholder}}
        </option>
        <option v-for="option in options" :key="option.id" :value="valueKey ? option[valueKey] : option" :disabled="option.disabled">
            {{option[textKey]}}
        </option>
    </select>
</template>
<script>
    export default {
        data () {
            return {
                newValue: '',
                user_set: false,
                pending: false,
            }
        },
        created () {
            this.newValue = this.currentValue
        },
        props: [
            'options',
            'valueKey',
            'textKey',
            'currentValue',
            'display',
            'placeholder',
            'allowUnset'
        ],
        methods: {
            userSet () {
                this.user_set = true
            },
            focus () {
                this.$el.focus()
            }
        },
        watch: {
            newValue: function () {
                if (this.user_set) {
                    this.pending = true
                    this.$emit('change', this.newValue)
                    
                    if (this.display == 'current') {
                        this.newValue = this.currentValue
                    }

                    this.user_set = false
                }
            },
            currentValue () {
                if (!this.user_set) {
                    this.pending = false
                }

                this.newValue = this.currentValue
            }
        }
    }
</script>